import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import TaskCompletionStepComments from '../TaskCompletionStepComments';
import DataSource from '../../../dao/DataSource/DataSource';
import { completion_criteria_root } from '../../../dao/CompletionCriteriaDAO';

import './CommentPopup.scss';

class CommentPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      menu: null,
      completionStep: this.props.completionStep,
    };
  }
  
  handleCSRetrieval(completionStep, action, acData, fetchedData){
    this.setState({ completionStep });
  }

  componentDidMount() {
    const { completionStep } = this.props;
    if (completionStep){
      this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completion_criteria_root, this.handleCSRetrieval);
      this.csDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { completionStep } = this.props;
    if (completionStep != prevProps.completionStep){
      if (this.csDataSource) {
        this.csDataSource.release();
      }
      this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completion_criteria_root, this.handleCSRetrieval);
      this.csDataSource.get();
    }
  }

  handleClickBackground(e) {
    if (e.target.id == 'comment-popup-background' || e.target.id == 'cancel-button') {
      if (this.props.cancelComment) {
        this.props.cancelComment();
      }
    }
  }

  render() {
    const { width, left, top, height } = this.props;
    const style = { width: width, left: left, top: top, height: height };
    return <div className="comment-popup" onClick={this.handleClickBackground} id="comment-popup-background">
      <div className="comment-container" style={style} id="comment-container">
        <div className="cancel-button" onClick={this.handleClickBackground} id="cancel-button"/>
        <TaskCompletionStepComments key={'comment-popup-' + this.state.completionStep.id} fromPopup={true} placeholder={this.props.placeholder}
          task={this.props.task} completionStep={this.state.completionStep} commentSent={this.props.commentSent} type={this.props.type} />
        </div>
      </div>;
  }
}

export default CommentPopup;



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/CommentPopup/index.js